// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zb2xH7sIF-ak3S {\n  display: inline-block;\n  line-height: 1;\n}\n.slkdx5W6nLFYn1 svg {\n  height: 14px;\n  width: 14px;\n  line-height: 14px;\n}\n.ttnK8PUoemc3bn svg {\n  height: 16px;\n  width: 16px;\n  line-height: 16px;\n}\n._7DPC8ZrrlGASp7 svg {\n  height: 20px;\n  width: 20px;\n  line-height: 20px;\n}\n.eF-AbDKCv1rLl4 svg {\n  height: 24px;\n  width: 24px;\n  line-height: 24px;\n}\n.amZ7sRpfY\\+zpf1 {\n  box-sizing: border-box;\n  padding: 3px 3px;\n}\n.yffeOvIsOcAAcA {\n  box-sizing: border-box;\n  padding: 2px 2px;\n}\n.trauwb\\+1Y6lrhD {\n  box-sizing: border-box;\n  padding: 6px 6px;\n}\n.cBEAUgjOa4Y4nM {\n  box-sizing: border-box;\n  padding: 4px 4px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nch-icon": "zb2xH7sIF-ak3S",
	"nch-icon--xsmall": "slkdx5W6nLFYn1",
	"nch-icon--small": "ttnK8PUoemc3bn",
	"nch-icon--medium": "_7DPC8ZrrlGASp7",
	"nch-icon--large": "eF-AbDKCv1rLl4",
	"nch-icon--xsmall-block": "amZ7sRpfY+zpf1",
	"nch-icon--small-block": "yffeOvIsOcAAcA",
	"nch-icon--medium-block": "trauwb+1Y6lrhD",
	"nch-icon--large-block": "cBEAUgjOa4Y4nM"
};
export default ___CSS_LOADER_EXPORT___;
